import { render } from "./face-mesh-view.vue?vue&type=template&id=32e594de&scoped=true"
import script from "./face-mesh-view.vue?vue&type=script&lang=js"
export * from "./face-mesh-view.vue?vue&type=script&lang=js"

import "./face-mesh-view.vue?vue&type=style&index=0&id=32e594de&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e594de"]])

export default __exports__